"use client";
import Expandable from "../Expandable/index.js";
import React from "react";
import AccordionContext from "./Accordion.context.js";
const AccordionContent = (props) => {
    const { children } = props;
    const { active, triggerId, contentId } = React.useContext(AccordionContext);
    return (React.createElement(Expandable, { active: active, attributes: { "aria-labelledby": triggerId, id: contentId } }, children));
};
export default AccordionContent;
